/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';
import Lottie from "lottie-react";
import iconPlus from './IconPlus_NoLoop_01.json';

const IconPlus = (props) => {
    return (
        <Lottie animationData={JSON.parse(JSON.stringify(iconPlus))} {...props}/>
    );
}

export default IconPlus;



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/animations/howItWorksIcons/iconPlus.jsx